<template>
  <v-container fluid class="event-detail">
    <v-layout column v-if="!loading" justify-start>
      <v-layout justify-space-between row fluid wrap style="margin-bottom: 20px" class="information-cell-container">
        <div class="information-cell-left">
          <ul>
            <li>
              <v-layout raw align-center>
                <div class="icon-20px">
                  <img :src="icons.eventsCalendar" />
                </div>
                {{ this.event.date }}
              </v-layout>
            </li>
            <li>
              <v-layout raw align-center>
                <div class="icon-20px">
                  <img :src="icons.clock" />
                </div>
                {{ this.event.start }} - {{ this.event.end }}
              </v-layout>
            </li>
            <li>
              <v-layout raw align-center>
                <div class="icon-20px">
                  <img :src="icons.location" />
                </div>
                {{ this.event.location }}
              </v-layout>
            </li>
            <li>
              <v-btn dark @click="goToEdit(event)" :color="colors['orange']" block class="ml-0">
                <v-icon>edit</v-icon>
                Edit Event
              </v-btn>
            </li>
            <li>
              <v-btn dark :disabled="!this.eventEnded" @click="resyncEventBP()" :loading="APILoading"
                :color="colors['bright-blue']" block class="ml-0">
                <v-icon>sync</v-icon>
                Re-Sync BP Session Data
              </v-btn>
            </li>
          </ul>
        </div>
        <div class="information-cell-central">
          <v-layout column align-center>
            <div class="event-type">
              <img :src="icons[String(this.event?.eventType).toLowerCase()]" />
            </div>
            <v-layout justify-space-around align-center wrap>
              <v-layout justify-space-around align-center>
                <!-- coach number -->
                <v-layout row justify-space-around align-center class="event-participants">
                  <img class="coach-icon" :src="icons.coach" />
                  {{ counters.nCoaches }}
                </v-layout>
                <!-- goalkeeper number -->
                <v-layout row justify-space-around align-center class="event-participants">
                  <img :src="icons.goalkeeper" />
                  {{ counters.nGoalkeepers }}
                </v-layout>
                <!-- defender number -->
                <v-layout row justify-space-around align-center class="event-participants">
                  <img :src="icons.defender" />
                  {{ counters.nDefenders }}
                </v-layout>
              </v-layout>
              <v-layout justify-space-around align-center>
                <!-- midfielder number -->
                <v-layout row justify-space-around align-center class="event-participants">
                  <img :src="icons.midfielder" />
                  {{ counters.nMidfielders }}
                </v-layout>
                <!-- striker number -->
                <v-layout row justify-space-around align-center class="event-participants">
                  <img :src="icons.striker" />
                  {{ counters.nStrikers }}
                </v-layout>
                <!-- total number -->
                <v-layout row justify-space-around align-center class="event-participants">
                  <img :src="icons.player" />
                  {{ counters.nPlayers }}
                </v-layout>
              </v-layout>
            </v-layout>
          </v-layout>
        </div>
        <div class="information-cell-right">
          <v-layout column align-center class="attending-div">
            <template v-if="eventEnded && this.event.postReport">
              <div class="small-dognut mr-2" style="position: relative">
                <bpChart :chartdata="eventReportChartData">
                  <span>ARPE</span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" class="info_icon" color="white">
                        fas fa-info-circle
                      </v-icon>
                    </template>
                    <span class="tooltip_text">
                      Average Rate of Perceived Exertion is used to measure the
                      intensity of a session among all attendees.
                    </span>
                  </v-tooltip>
                </bpChart>
              </div>
            </template>
            <template v-else>
              <template v-if="$route.params.isPast || this.eventEnded">
                <span>Attended</span>
              </template>
              <template v-else>
                <span>Attending</span>
              </template>
              <span class="white-line"></span>
              <v-layout justify-space-around align-center class="attending-div-buttons">
                <v-btn fab color="green" :style="{
                    opacity:
                      userAttendingStatus ===
                      constants.userAttendingStatus.attending
                        ? 1
                        : 0.3,
                  }" @click="attending()">
                  <v-icon>check</v-icon>
                </v-btn>
                <v-btn fab color="red" :style="{
                    opacity:
                      userAttendingStatus ===
                      constants.userAttendingStatus.notAttending
                        ? 1
                        : 0.3,
                  }" @click="notAttending()">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-layout>
            </template>
          </v-layout>
        </div>
      </v-layout>
      <v-flex class="event-detail-users-list">
        <v-card class="v-tabs__container">
          <v-tabs slider-color="transparent" v-model="tab" fixed-tabs>
            <v-tab class="">
              {{
              this.$moment(this.event.fullDate).isBefore()
              ? "Attended"
              : "Attending"
              }}
            </v-tab>
            <v-tab lass="">
              {{
              this.$moment(this.event.fullDate).isBefore()
              ? "Not Attended"
              : "Not Attending"
              }}
            </v-tab>
            <v-tab lass="">
              {{ "No Response" }}
            </v-tab>
          </v-tabs>
          <div class="search-and-sort">
            <v-text-field dark solo-inverted prepend-inner-icon="fas fa-search" v-model="search" label="Search"
              clearable @input="searchPlayer()" class="search-line"></v-text-field>
            <v-tooltip bottom color="green">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" class="sort" fab icon @click="reSort()" :color="colors['white']">
                  <v-icon>{{ sortIcon }}</v-icon>
                </v-btn>
              </template>
              <span style="">Reverse Alphabetic sorting</span>
            </v-tooltip>
          </div>
          <v-tabs-items v-model="tab">
            <v-card flat>
              <v-tab-item v-if="sortTabMap[tab].arr.length">
                <EventDetailUserListRow v-for="(user, index) in sortTabMap[tab].arr"
                  :key="`${index}-${sortAscending}-${tab}`" :user="user" :event="event"
                  :biometricData="user.biometricData" @user-details-requested="
                    userDetails(user)
                  "></EventDetailUserListRow>
              </v-tab-item>
              <v-tab-item v-else>
                <v-card flat>
                  <v-card-text>
                    <v-layout column align-center justify-center>
                      <v-icon size="100" color="white">
                        mdi-account-question
                      </v-icon>
                      <span class="white--text">
                        No players match your search
                      </span>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-card>
            <v-card flat>
              <v-tab-item v-if="sortTabMap[tab].arr.length">
                <EventDetailUserListRow v-for="(user, index) in sortTabMap[tab].arr"
                  :key="`${index}-${sortAscending}-${tab}`" :user="user" :event="event"
                  :biometricData="user.biometricData" @user-details-requested="
                    userDetails(user)
                  "></EventDetailUserListRow>
              </v-tab-item>
              <v-tab-item v-else>
                <v-card flat>
                  <v-card-text>
                    <v-layout column align-center justify-center>
                      <v-icon size="100" color="white">
                        mdi-account-question
                      </v-icon>
                      <span class="white--text">
                        No players match your search
                      </span>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-card>
            <v-card flat>
              <v-tab-item v-if="sortTabMap[tab].arr.length">
                <EventDetailUserListRow v-for="(user, index) in sortTabMap[tab].arr"
                  :key="`${index}-${sortAscending}-${tab}`" :user="user" :event="event"
                  :biometricData="user.biometricData" @user-details-requested="
                    userDetails(user)
                  "></EventDetailUserListRow>
              </v-tab-item>
              <v-tab-item v-else>
                <v-card flat>
                  <v-card-text>
                    <v-layout column align-center justify-center>
                      <v-icon size="100" color="white">
                        mdi-account-question
                      </v-icon>
                      <span class="white--text">
                        No players match your search
                      </span>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-card>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import constants from "@/constants.js"
import EventDetailUserListRow from "./strips/EventDetailUserListRow.vue"
import firebaseApi from "@/api/firebase.api.js"
import { apiWrapper } from "@/lib/utils"
import bpChart from "./strips/bpChart"
import { mapGetters } from "vuex"
import colors from "@/assets/sass/_variables.sass"
import { reSyncBP } from "@/api/firestoreAPI.ts"
import { logSentryError } from "@/mixins/utils.mixin"

export default {
  name: "EventDetail",
  components: {
    EventDetailUserListRow,
    bpChart,
  },
  data() {
    return {
      colors,
      tab: 0,
      items: [],
      text: "",
      loading: true,
      APILoading: false,
      currentUser: this.$store.state.user.current,
      constants,
      userAttendingStatus: null,
      icons: constants.icons,
      event: null,
      eventEnded: true,
      eventReport: 0,
      individualReportScores: {},
      flipFlop: false,
      bpChartOptions: {
        cutoutPercentage: 80,
        tooltips: { enabled: false },
        hover: { mode: null },
      },
      eventReportChartData: null,
      search: "",
      sortTabMap: {
        0: { name: "attendees", arr: [] },
        1: { name: "absentees", arr: [] },
        2: { name: "noResponse", arr: [] },
      },
      sortAscending: false,
    }
  },
  methods: {
    searchPlayer() {
      const tabsToComputedProps = {
        0: "attendees",
        1: "absentees",
        2: "noResponse",
      }
      const tmpSquad = this.sortTabMap[this.tab].arr.length
        ? this.sortTabMap[this.tab].arr
        : this[tabsToComputedProps[this.tab]]
      if (!this.search || this.search.trim() === "") {
        this.sortTabMap[this.tab].arr = this[tabsToComputedProps[this.tab]]
        return
      }
      const filterRegExp = new RegExp(this.search, "gi")
      const found =
        tmpSquad?.filter((player) => {
          return (
            filterRegExp.test(player.firstName) ||
            filterRegExp.test(player.lastName)
          )
        })
      this.sortTabMap[this.tab].arr = found
    },
    reSort(doAll = false) {
      this.sortAscending = !this.sortAscending
      this.search = ""
      const tabsInvolved = doAll ? Object.keys(this.sortTabMap) : [this.tab]
      for (const tab of tabsInvolved) {
        const toSort = this[this.sortTabMap[tab].name]
        this.sortTabMap[tab].arr = this.$_.orderBy(toSort, ["firstName", "asc"])
        if (!this.sortAscending) {
          this.sortTabMap[tab].arr = this.$_.reverse(this.sortTabMap[tab].arr)
        }
      }
    },
    async resyncEventBP() {
      this.APILoading = true
      const team = this.$store.getters["teamList/activeTeam"]
      const eventId = this.$route.params.id
      try {
        const res = await reSyncBP(this.event, eventId, team)
        console.log(res)
        this.APILoading = false
        this.$toast.success("BeyondPulse re-sync request sent.")
      } catch (e) {
        console.error(e)
        logSentryError("re-sync BP issue", "error", {
          error: JSON.stringify(e),
          fn: "reSyncBP",
          eventId,
          teamId: team.id,
          userId: this.$store.state.user.current.uid,
        })
        this.loading = false
        const eMessage =
          e?.response?.data ?? e?.message ?? "Oops... something went wrong."
        this.$toast.error(this.$_.capitalize(eMessage))
      }
    },
    goToEdit(event) {
      this.$store.dispatch("fsNotifications/updateEventListenerId", event.id)
      this.$router.push({
        name: "EditEvent",
        params: { action: "update", ...event },
      })
    },
    async reloadEventDetails() {
      const eventId = this.$route.params.id
      const userId = this.userId || sessionStorage.getItem("userId")
      const teamId = this.teamId || sessionStorage.getItem("lastSelectedTeam")
      // console.log(
      //   `refetching event details. event = ${eventId}, user =  ${userId}, team =  ${teamId}`
      // )
      const refetchedEvent = await firebaseApi.getEventDetails({
        eventId,
        userId,
        teamId,
      })
      this.event = this.formatEvent(refetchedEvent)
    },
    async loadEventDetails() {
      const event = { ...this.$route.params }
      this.event = { ...event }
      const eventKeys = Object.keys(this.event)
      if (eventKeys.length <= 1) {
        await this.reloadEventDetails()
      }

      // TODO: fix error in prod where event.date wasn't defined
      try {
        this.eventEnded = this.$moment(
          `${this.event.date} ${this.event.end}`,
          "dddd, MMMM Do YYYY h:mm a"
        ).isBefore()
      } catch (e) {
        logSentryError("Error in event detail date parsing", "error", {
          error: e,
          eventId: this.event.id,
          userId: this.userId,
          extra: {
            event,
            eventKeys,
            eventDate: this.event.date,
            eventEnd: this.event.end,
          },
        })
      }
      if (this.eventEnded) {
        this.eventReport = await apiWrapper(firebaseApi.getEventRPEs, [
          this.event.id,
        ])
      }

      if (typeof this.eventReport === "object") {
        this.individualReportScores = this.eventReport.individualScores
        this.eventReport = this.eventReport.overall
      }

      let color = ""

      if (this.eventReport > 0 && this.eventReport <= 3) {
        color = "#02c905"
      } else if (this.eventReport > 3 && this.eventReport <= 6) {
        color = "#eded02"
      } else if (this.eventReport > 6 && this.eventReport <= 8) {
        color = "#ff9800"
      } else if (this.eventReport > 8) {
        color = "#ed0202"
      }

      this.eventReportChartData = {
        // data: [this.eventReport, 10 - this.eventReport]
        // borderWidth: [0, 0],
        data: this.eventReport,
        color: { color },
        meta: {
          showPercent: false,
          scale: 10,
          precision: 1,
        },
      }

      this.updateUsersStatus()
      this.loading = false
      this.flipFlop = !this.flipFlop
      // })
      // .catch((e) => console.error(e))
    },
    attending() {
      const payload = {
        eventId: this.$route.params.id,
        value: true,
      }

      if (this.teamId) {
        payload.teamId = this.teamId
      }
      this.$store
        .dispatch("setUserAttending", payload)
        .then(async () => {
          await this.reloadEventDetails()
          this.updateUsersStatus()
        })
        .catch((e) => console.error(e))
    },
    notAttending() {
      const payload = {
        eventId: this.$route.params.id,
        value: false,
      }

      if (this.teamId) {
        payload.teamId = this.teamId
      }
      this.$store
        .dispatch("setUserAttending", payload)
        .then(async () => {
          await this.reloadEventDetails()
          this.updateUsersStatus()
        })
        .catch((e) => console.error(e))
    },
    updateUsersStatus() {
      // update user status
      if (this.event.attendees[this.userId]) {
        this.userAttendingStatus = this.constants.userAttendingStatus.attending
      } else if (this.event.absentees[this.userId]) {
        this.userAttendingStatus =
          this.constants.userAttendingStatus.notAttending
      } else {
        this.userAttendingStatus = this.constants.userAttendingStatus.noResponse
      }
    },
    userDetails(user) {
      const id = user.id ?? user.uid
      // go to user details
      // console.log(user)
      this.$router.push({ name: "PlayerStatus", params: { id } })
    },
    elementsCount(event) {
      if (!event) {
        return
      }
      let nCoaches = 0
      let nPlayers = 0
      let nGoalkeepers = 0
      let nDefenders = 0
      let nMidfielders = 0
      let nStrikers = 0
      this.attendees.forEach((element) => {
        if (element.coachOrPlayer === "Coach") {
          nCoaches++
          return
        }
        nPlayers++
        switch (element.position) {
          case constants.positions.goalkeeper:
            nGoalkeepers++
            break
          case constants.positions.defender:
            nDefenders++
            break
          case constants.positions.midfielder:
            nMidfielders++
            break
          case constants.positions.forward:
            nStrikers++
            break
          default:
            break
        }
      })
      return {
        nCoaches,
        nPlayers,
        nGoalkeepers,
        nDefenders,
        nMidfielders,
        nStrikers,
      }
    },
    formatEvent(event) {
      if (!event) {
        return
      }
      let date = new Date(event.dateAsNumber * 1000)
      date = this.$moment(date).second(0)
      const formattedEvent = {}
      formattedEvent.fullDate = event.dateAsNumber
      formattedEvent.id = event.id
      formattedEvent.mDate = date
      formattedEvent.duration = event.duration
      formattedEvent.date = date.format("dddd, MMMM Do YYYY")
      formattedEvent.start = date.format("h:mm a")
      formattedEvent.end = date.add(event.duration, "m").format("h:mm a")
      formattedEvent.eventType = event.eventType
      formattedEvent.location = event.location
      formattedEvent.postReport = event.postReport === "Yes"
      formattedEvent.attendees = event.attendees || {}
      formattedEvent.absentees = event.absentees || {}
      formattedEvent.biometricData = event.biometricData || []
      formattedEvent.individualReportScores = event.individualScores || {}
      return formattedEvent
    },
  },
  computed: {
    sortIcon() {
      return this.sortAscending
        ? "mdi-sort-alphabetical-ascending"
        : "mdi-sort-alphabetical-descending"
    },
    userId() {
      return (
        this.$store?.state?.user?.profile?.uid ??
        sessionStorage.getItem("userId") ??
        false
      )
    },
    teamId() {
      return this.$store.getters["teamList/activeTeam"].id ?? false
    },
    counters() {
      return this.elementsCount(this.event)
    },
    teamMembers() {
      return (
        this.$store.getters["teamList/activeTeamPlayers"] || [
          this.$store.state.user.profile,
        ]
      )
    },
    ...mapGetters("teamList", ["activeTeamPlayers"]),
    attendees() {
      // if (!this.event.attendees) {
      //   return []
      // }
      const uniqueAttendees = new Set()
      // const attendeesList =
      Object.keys(this.event.attendees).forEach((member) => {
        uniqueAttendees.add(member)
      })
      // const usersWithBioData =
      this.event?.biometricData?.forEach((user) => {
        uniqueAttendees.add(user.uid)
      })

      if (this.individualReportScores) {
        for (const playerId in this.individualReportScores) {
          if (
            Object.hasOwnProperty.call(this.individualReportScores, playerId)
          ) {
            const score = this.individualReportScores[playerId]
            if (score > 0) {
              uniqueAttendees.add(playerId)
            }
          }
        }
      }

      // if (attendeesList?.length) {
      //   attendeesList.forEach((id) => {
      //     uniqueAttendees.add(id)
      //   })
      // }
      // if (usersWithBioData?.length) {
      //   usersWithBioData.forEach((id) => {
      //     uniqueAttendees.add(id)
      //   })
      // }
      const uniqueAttendeesArray = [...uniqueAttendees].filter((member) => {
        return this.activeTeamPlayers?.find((player) => {
          return player.uid === member
        })
      })
      const uniqueAttendeesObjArray = uniqueAttendeesArray.map((member) => {
        const teamPlayerData = this.activeTeamPlayers?.find((player) => {
          return player.uid === member
        })
        const biometricData = this.event?.biometricData?.find((player) => {
          return player.uid === member
        })
        if (!teamPlayerData) {
          return {}
        }
        if (!biometricData) {
          return {
            ...teamPlayerData,
          }
        }

        return {
          ...teamPlayerData,
          biometricData,
        }
      })

      return this.$_.orderBy(uniqueAttendeesObjArray, ["firstName", "asc"])
    },
    absentees() {
      if (!this.event.absentees) {
        return []
      }
      return this.$_.orderBy(
        this.$_.intersectionBy(
          this.teamMembers,
          Object.keys(this.event.absentees).map((member) => {
            return { id: member }
          }),
          "id"
        ),
        ["firstName", "asc"]
      )
    },
    noResponse() {
      // const attendeesList = this.event.attendees
      //   ? Object.keys(this.event.attendees)
      //   : []

      const absenteesList = this.event.absentees
        ? Object.keys(this.event.absentees)
        : []
      const responseMember = absenteesList.concat(this.attendees)
      const noResponseMembers = this.teamMembers.filter((member) => {
        return !responseMember.find((m) => m.uid === member.uid)
      })
      return this.$_.orderBy(noResponseMembers, ["firstName", "asc"])
    },
  },
  async mounted() {
    await this.loadEventDetails()
    this.reSort(true)
  },
}
</script>

<style lang="sass">
@import '@/assets/sass/globals.sass'
.information-cell-container
  height: 100%

.event-detail
  background-color: $bg-gray-gradient
  color: white
  width: 100%
  height: inherit
  margin: 10px auto 0px auto !important

  .information-cell-left, .information-cell-right
    height: fit-content
    margin: 10px auto

    .icon-20px
      height: 20px
      width: 20px
      margin-right: 10px

      img
        margin: auto
        display: block

    ul
      padding: 0px

      li
        list-style: none
        // height: 30px
        margin-bottom: 0.3rem

        i
          margin-right: 5px

    .attending-div
      width: 9rem

      .attending-div-buttons
        width: 100%
        margin: 0.4rem auto

      .white-line
        height: 2px
        margin-top: 3px
        background-color: white

      span
        width: 100%
        text-align: center

  .information-cell-central
    width: 360px
    height: fit-content
    margin-bottom: 10px

    .event-type
      margin-bottom: 30px

      img
        width: 80px

    .event-participants
      width: 50px
      max-width: 50px
      height: 50px
      border: 1px solid white
      border-radius: 50px
      padding-right: 5px
      margin: 5px

      img
        height: 25px

      .coach-icon
        height: 20px

.event-detail-users-list
  .v-tabs__container
    box-shadow: none !important
    width: 100%
    background: transparent !important
    .search-and-sort
      display: grid
      grid-auto-flow: column
      grid-auto-columns: 11fr 1fr
      .sort
        background-color: $bright-blue
        margin: 0.25rem auto
      .search-line .v-input__slot
        // z-index: 10
        margin-top: 0.5rem
        opacity: 1
        // background-color: $white
        background-color: transparentize($bright-blue, 0.7)
        border-radius: 10px !important
        border: 1px solid white

        .v-label, .v-icon
          color: $white !important
          color: $white !important
        input
          color: $white !important
    .v-slide-group__wrapper
      background: #1f244d
      .v-slide-group__content.v-tabs-bar__content
        background: #1f244d
        .v-tab
          color: white
          &:nth-child(2)
            border: 1px solid white
            border-radius: 10px 0 0 10px
          &:nth-child(3)
            border-top: 1px solid white
            border-bottom: 1px solid white
          &:nth-child(4)
            border: 1px solid white
            border-radius: 0 10px 10px 0

        .v-tab--active
          border-radius: inherit
          background-color: transparentize($bright-blue, 0.7)
.v-window__container
  background: #1f244d
  .v-sheet.v-card
    background: #1f244d
    color: white

  @media all and (max-width: 770px)
    .information-cell-container
      .information-cell-central
        order: 0
        width: 100%

      .information-cell-left
        order: 1

      .information-cell-right
        order: 2
</style>
